'use strict';

export default class CustomSlider {

    constructor() {
        this.template = document.querySelector('#custom-slider-template');
        this.slideTemplate = document.querySelector('#custom-slide-template');
        this.index = 0;
    }

    buildSlider(sliders, onClickFunction = null, showTitle = false) {
        this.index = 0;
        const customSlider = this.template.content.cloneNode(true);
        this.slidersContainer = customSlider.querySelector('[name="sliders-container"]');
        this.addSlideElements(sliders, onClickFunction);

        const sliderOffset = document.querySelector('[data-entity="sliderTitle"]');
        if (sliderOffset && showTitle) {
            customSlider.querySelector('[name="slider-title"]').style.height = sliderOffset.clientHeight + "px";
        }
        return customSlider.querySelector('[name="slider-container"]');
    }

    addSlideElements(sliders, onClickFunction) {
        let slideElement, sliderElement;
        for (let slider of sliders) {
            slideElement = this.slideTemplate.content.cloneNode(true);
            sliderElement = slideElement.querySelector('[name="slider"]');
            sliderElement.setAttribute('num', this.index);
            sliderElement.setAttribute('slider-id', this.index);
            sliderElement.appendChild(slider);
            if (onClickFunction) {
                sliderElement.addEventListener("click", (event) => {
                    onClickFunction(event.currentTarget.getAttribute('num'));
                });
            }
            this.slidersContainer.appendChild(slideElement);
            this.index++;
        }
    }
}
